@import "~@govbr-ds/core/src/components/checkbox/checkbox";

:host {
  display: inline-block;

  .br-checkbox {
    --checkbox-padding: var(--spacing-scale-half);
    --checkbox-size: 24px;

    display: flex;
    position: relative;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    white-space: nowrap;
    border: 0;
  }
}
